import React from 'react';
import {Box} from '@material-ui/core';

const Success: React.FC<{}> = () => (
	<Box>
		<div>Your Pre-Order is confirmed.</div>
	</Box>
);

export default Success;
